//Please add the language resource
const toxinInspectVehicleManual = {
  appointmentNo:'预约单号',
  vehicleNo:"车牌号",
  vehicleTypeName:"车型",
  grainOriginName:'粮源地',
  toxinExemptOptUserNo:'设定人',
  toxinExemptOptTime:'设定时间',
  supplierName:'供应商',
  contractTypeName:'订单类型',
  msg:{
    }
};
export default toxinInspectVehicleManual



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectVehicleManual/lang/toxinInspectVehicleManual.en.js